module.exports = __webpack_public_path__ + "img/logo-UMC.13e36f4c.svg";